module.exports = __webpack_public_path__ + "assets/img/search_2.5b062a47.png";